<template>
	<FormDropdown label="<i class='fas fa-ellipsis-v' style='height: 100%;'></i>">
		<div class="container__markers__do__mapa__switchers">
			<Switcher
				:label="$t('showSectionCode')"
				:click-listener="alterarExibicaoMarkerDeTalhao"
			/>
			<Switcher
				:label="$t('showPlantationsCode')"
				:click-listener="alterarExibicaoMarkerDePlantio"
			/>
			<Switcher
				:label="$t('showOccurencies')"
				:click-listener="alterarExibicaoMarkerDeOcorrencia"
			/>
		</div>
	</FormDropdown>
</template>

<script>
import FormDropdown from '../../../../../components/FormDropdown/FormDropdown'
import Switcher from '../../../../../components/Switcher/Switcher'

export default {
	components: {
		FormDropdown,
		Switcher,
	},
	props: {
		alterarExibicaoMarkerDeTalhao: {
			type: Function,
			required: true,
		},
		alterarExibicaoMarkerDePlantio: {
			type: Function,
			required: true,
		},
		alterarExibicaoMarkerDeOcorrencia: {
			type: Function,
			required: true,
		},
	},
}
</script>

<style scoped>
.container__markers__do__mapa__switchers div:nth-child(n + 2) {
	margin-top: 0.5rem;
}
</style>
